var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunicateStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66657 10.3119C5.54464 10.6356 5.00822 10.6356 4.88635 10.3119C4.53279 9.37205 3.95358 8.0899 3.20918 7.34549C2.4648 6.60108 1.18258 6.02179 0.242923 5.66831C-0.0809746 5.54638 -0.0809746 5.01001 0.242923 4.88808C1.18258 4.5346 2.4648 3.95531 3.20918 3.2109C3.95358 2.46649 4.53279 1.18434 4.88635 0.244738C5.00822 -0.0792153 5.54464 -0.0792153 5.66657 0.244738C6.02004 1.18434 6.59933 2.46649 7.34374 3.2109C8.08814 3.95531 9.37028 4.5346 10.3102 4.88808C10.6338 5.01001 10.6338 5.54638 10.3102 5.66831C9.37028 6.02179 8.08814 6.60108 7.34374 7.34549C6.59933 8.0899 6.02004 9.37205 5.66657 10.3119Z",
    fill: "#CDD7D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicateStarIcon);
export default __webpack_public_path__ + "static/media/communicate-star-icon.49b752c32256249ac129179379dc9fdd.svg";
export { ForwardRef as ReactComponent };